module.exports = __webpack_public_path__ + "static/image8-014c62caad60d82a4a5bb856e68d5f0b.jpg";